export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmailWithMessage = (email) => {
  if (!email || typeof email !== "string") {
    return { valid: false, message: "Email is required." };
  }

  const trimmedEmail = email.trim();

  if (trimmedEmail === "") {
    return { valid: false, message: "Email cannot be empty." };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(trimmedEmail)) {
    return { valid: false, message: "Invalid email format." };
  }

  return { valid: true, message: "Valid email." };
};
export const isValidEmail = (email) => emailRegex.test(email);

export const isValidPhoneNumber = (phone) => {
  const digitsOnly = phone.replace(/\D/g, "");
  return digitsOnly.length >= 10 && digitsOnly.length <= 15;
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0 });
};
